module.exports = __webpack_public_path__ + "static/media/ingredients.15e9e41b.png";